import { IModuleConfig } from "./modules/types";
import { translate } from "./languages";

const moduleConfig: IModuleConfig = {
    translate: (id: string, values?: any) => translate(id, values),
    getLocaleList: () => [
        {
            key: 'English',
            label: 'ENG',
            isActive: true,
        },
    ]
}

export default moduleConfig;